import { render, staticRenderFns } from "./departmentDelete.vue?vue&type=template&id=3f1a862e&"
import script from "./departmentDelete.vue?vue&type=script&lang=js&"
export * from "./departmentDelete.vue?vue&type=script&lang=js&"
import style0 from "./departmentDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports